


























































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import Calendar from "../general/Calendar.vue";
import GroupsBookingDetails from "./GroupsBookingDetails.vue";

import CalendarUtils from "../../shared/CalendarUtils";
import CalendarEventJson from "../../shared/CalendarEventJson";

import UserJson from "../../shared/UserJson";
import GroupBookingJson from "../../shared/GroupBookingJson";

import { GroupBookingStatus } from "../../shared/GroupBookingStatus";

export default Vue.extend({
  name: "GroupsCalendar",
  components: {
    Loading,
    Calendar,
    GroupsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    GroupsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      loading: false,
      showDetails: false,
      selectedReservedAndBookedGroups: null as GroupBookingJson[] | null,
      dateToShow: null as Date | null,
      currentCalenderYearMonth: null as [number, number] | null,
      selectedGroupBookingId: null as number | null,
      selectedGroupBooking: null as GroupBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    loadData() {},

    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadSelectedGroupBooking();
      }
    },

    reloadSelectedGroupBooking() {
      this.loadSelectedReservedAndBookedGroups();
    },

    async loadSelectedReservedAndBookedGroups() {
      if (this.currentCalenderYearMonth != null) {
        this.selectedReservedAndBookedGroups = null;

        var states: GroupBookingStatus[] = [
          GroupBookingStatus.requested,
          GroupBookingStatus.offerToCustomer,
          GroupBookingStatus.offerAccepted,
          GroupBookingStatus.booked,
        ];
        var afterDateTime = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1], -7);
        var beforeDateTime = new Date(this.currentCalenderYearMonth[0], this.currentCalenderYearMonth[1], 38);

        if (this.restClient != null) {
          try {
            var result = await this.restClient.getGroupBookings(
              states,
              null,
              afterDateTime,
              beforeDateTime,
              null,
              null,
              null
            );

            var groupBookings = result.groupBookings;

            while (result.moreAvailable) {
              result = await this.restClient.getGroupBookings(
                states,
                null,
                afterDateTime,
                beforeDateTime,
                null,
                null,
                groupBookings.length
              );
              groupBookings = groupBookings.concat(result.groupBookings);
            }

            this.selectedReservedAndBookedGroups = groupBookings;
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    jumpToDateInCal(date: Date) {
      this.dateToShow = date;
    },

    getCalendarEvents() {
      let events: CalendarEventJson[] = [];

      if (this.selectedReservedAndBookedGroups != null) {
        for (let i = 0; i < this.selectedReservedAndBookedGroups.length; i++) {
          let event: CalendarEventJson = {
            title: "",
            beginDateTime: "",
            endDateTime: "",
            state: "",
            eventData: {},
          };

          event.title = this.selectedReservedAndBookedGroups[i].customer.guardianOrganisation;
          event.beginDateTime = this.selectedReservedAndBookedGroups[i].beginDateTime;
          event.endDateTime = this.selectedReservedAndBookedGroups[i].endDateTime;
          event.state = this.selectedReservedAndBookedGroups[i].state;

          event.eventData = this.selectedReservedAndBookedGroups[i];

          events.push(event);
        }
      }

      return events;
    },

    calenderCurrentYearMonth(year: number, month: number) {
      this.currentCalenderYearMonth = [year, month];
    },

    openDetails(item: GroupBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedGroupBookingId = item.ID;
      } else {
        this.selectedGroupBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadSelectedGroupBooking();
      }
    },

    currentCalenderYearMonth: function () {
      this.loadSelectedReservedAndBookedGroups();
    },
  },
  computed: {},
});
